import { render, staticRenderFns } from "./PanelesConfiguracion.vue?vue&type=template&id=576be903&scoped=true&"
import script from "./PanelesConfiguracion.vue?vue&type=script&lang=ts&"
export * from "./PanelesConfiguracion.vue?vue&type=script&lang=ts&"
import style0 from "./PanelesConfiguracion.vue?vue&type=style&index=0&id=576be903&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576be903",
  null
  
)

export default component.exports